import { Link } from "react-router-dom";
import Button from "./Button";
import Card from "./Card";

export default function EmptyState({
  title = "No matches found",
  message = "Try adjusting your search or filters.",
  primaryAction,
  secondaryAction,
}) {
  return (
    <Card className="mx-auto max-w-3xl p-8 text-center sm:p-10">
      <div className="mx-auto mb-5 flex h-20 w-20 items-center justify-center rounded-full border border-hookd-gold/40 bg-hookd-gold/10 text-4xl text-hookd-gold shadow-gold">
        ♕
      </div>
      <h2 className="font-display text-3xl font-bold text-hookd-cream sm:text-4xl">
        {title}
      </h2>
      <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-hookd-muted">
        {message}
      </p>
      {(primaryAction || secondaryAction) && (
        <div className="mt-7 grid gap-3 sm:flex sm:justify-center">
          {primaryAction && (
            <Button as={Link} to={primaryAction.to} onClick={primaryAction.onClick}>
              {primaryAction.label}
            </Button>
          )}
          {secondaryAction && (
            <Button
              as={secondaryAction.to ? Link : "button"}
              to={secondaryAction.to}
              onClick={secondaryAction.onClick}
              variant="outline"
            >
              {secondaryAction.label}
            </Button>
          )}
        </div>
      )}
    </Card>
  );
}
